// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","p":"Footer_p__t2kx+","span":"Footer_span__+zopm"};